export const Carrier = 'Carrier';
export const Provider = 'Provider';
